import { Component, computed, input, output, signal, viewChild } from '@angular/core';
import { RidContentCard } from '../../components/rid-content-card/rid-content-card';
import { RidMechanicBackground } from '../../components/rid-mechanic-background/rid-mechanic-background';
import { RidMechanicContent } from '../../components/rid-mechanic-content/rid-mechanic-content';
import { RidMechanicTitle } from '../../components/rid-mechanic-title/rid-mechanic-title';
import { RidMechanicWrapper } from '../../components/rid-mechanic-wrapper/rid-mechanic-wrapper';
import { RidOverlayFeedback } from '../../components/rid-overlay-feedback/rid-overlay-feedback';
import { RidTopBar } from '../../components/rid-top-bar/rid-top-bar';

@Component({
  selector: 'rid-odd-one-out',
  imports: [RidMechanicBackground, RidMechanicWrapper, RidTopBar, RidMechanicContent, RidMechanicTitle, RidOverlayFeedback, RidContentCard],
  templateUrl: './rid-odd-one-out.html',
  host: {
    class: 'block',
  },
})
export class RidOddOneOut {
  questions = input.required<{ id: string; question: string; options: [string, string, string, string]; answer: 0 | 1 | 2 | 3 }[]>();

  index = signal(0);
  question = computed(() => this.questions()[this.index()]);

  progress = signal(0);
  isChecking = signal(false);
  overlayFeedback = viewChild.required<RidOverlayFeedback>('overlayFeedback');
  chosen = signal<undefined | number>(undefined);

  finished = output<void>();

  async choose(index: number) {
    this.chosen.set(index);
    this.isChecking.set(true);

    if (index === this.question().answer) {
      const isLastIndex = this.index() === this.questions().length - 1;

      if (isLastIndex) this.progress.set(this.progress() + 1);

      await this.overlayFeedback().showCorrect();

      if (isLastIndex) {
        this.finished.emit();
      } else {
        this.progress.set(this.progress() + 1);
        this.index.set(this.index() + 1);
      }
    } else {
      await this.overlayFeedback().showIncorrect();
    }

    this.chosen.set(undefined);
    this.isChecking.set(false);
  }
}
